<template>
  <modal :show.sync="value"
         @close="cancel"
         modal-classes="modal-fullscreen modal-centered">
    <h4 slot="header" class="modal-title" id="modal-title-notification">{{ $t('Select video for this lesson') }}</h4>
    <div>
      <tabs tabNavClasses="nav-fill nav-wrapper"
            tabContentClass="card">
        <tab-pane id="markdown-editor">
          <div slot="title">
            <i class="ni ni-upload"></i>
            {{ $t('Upload') }}
          </div>
          <uppy-widget
            v-if="optionsLoaded"
            :uploadUrl="tusUrl"
            :chunkSize="tusChunkSize"
            @complete="onComplete"
          ></uppy-widget>
        </tab-pane>
        <tab-pane id="markdown-preview">
          <div slot="title">
            <i class="fa fa-film"></i>
            {{ $t('Preview and pick') }}
          </div>
          <div class="row">
            <template v-for="video in videos">
              <div class="col-lg-4 col-xs-12 col-sm-12 col-md-6">
                <div class="card card-video">
                  <div class="card-header"
                      v-text="video.fileName">
                  </div>
                  <playerjs-player
                    :id="video.id"
                    :output-url="video.outputUrl"
                    :poster="video.thumbnailUrl"
                  ></playerjs-player>
                  <base-button
                    @click="pick(video.id)"
                    class="mx-auto btn-outline-default btn-pick-video">
                    {{ $t('Select') }}
                  </base-button>
                </div>
              </div>
            </template>
          </div>
        </tab-pane>
      </tabs>
    </div>
  </modal>
</template>

<script>
  import PlayerjsPlayer from "../Players/PlayerjsPlayer";
  import {PlayerjsMixin} from "../../mixins/Video/Playerjs";
  import TabPane from '@/components/Tabs/Tab.vue';
  import Tabs from '@/components/Tabs/Tabs.vue';
  import UppyWidget from "../Uppy/UppyWidget";

  export default {
    name: "ModalVideosPicker",
    components: {UppyWidget, PlayerjsPlayer, Tabs, TabPane},
    mixins: [
      PlayerjsMixin
    ],
    props: {
      value: {
        type: Boolean,
        default: false,
        description: "Show/hide modal state"
      },
      videos: {
        type: [Array],
        required: true
      },
    },
    async created() {
      await this.getUploadOptions();
    },
    mounted() {
      this.loadPlayerJs()
    },
    computed: {
      options() {
        return this.$store.state.course.video.uploadOptions
      },
      optionsLoaded() {
        return this.tusUrl && this.tusChunkSize;
      },
      tusUrl() {
        return this.options.tusUploadUrl;
        // return `/uploads/${this.$route.params.courseId}/videos`
      },
      tusChunkSize() {
        return Number(this.options.tusChunkSize);
      },
    },
    methods: {
      async getUploadOptions(){
        await this.$store.dispatch(
          'course/video/getUploadOptions',
          { urlParams: this.$route.params }
          );
      },
      cancel() {
        this.$emit('onCancel')
      },
      pick(id) {
        this.$emit("onPickVideo", id)
      },
      async onComplete(e) {
        console.log(e)
        await this.$store.dispatch(
        'course/video/loadVideos',
        { urlParams: this.$route.params }
        );
      }
    },

  }
</script>

<style lang="scss">
.modal-fullscreen {
  max-width: 90% !important;
}
.card.card-video {
  .card-header {
    max-width: calc(100% - 110px);
  }
}
.btn-pick-video {
  position: absolute;
  right: 1rem;
  top: 0.75rem;
}
</style>
